import { InveniasFileTypes, InveniasListTypes, InveniasNamespace } from 'datasource-service-lib';
import { InveniasMockNamespace } from 'datasource-service-lib';
import { IFileDataSourceApiService } from 'interfaces-lib';
import { IIconService } from 'interfaces-lib';
import { IWorkflowService } from 'interfaces-lib';
import { INamedEntityService } from 'named-entity-service-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IFileListViewConfig } from '../../file-list-view/file-list-view.component';
import { IFileListProvider } from '../../interfaces/ifilelistprovider';
import { AlreadyExistsLocalFileChecker } from '../../interfaces/localfilechecker';
import { ServiceProviderService } from '../service.provider.service';
import { InveniasFileToPathConverter } from './invenias.filetopathconverter';

export class InveniasFileListViewConfig implements IFileListViewConfig {
  readonly namespace = InveniasNamespace.name;
  readonly fileListProvider: IFileListProvider;
  readonly fileDataSourceApiService: IFileDataSourceApiService;
  readonly workflowService: IWorkflowService;
  readonly namedEntityService: INamedEntityService;
  readonly iconService: IIconService;
  readonly fileToPathConverter = new InveniasFileToPathConverter(InveniasListTypes.Documents);
  readonly localFileChecker = AlreadyExistsLocalFileChecker;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory) {
    const dataSourceApiService = serviceProviderService.getDataSourceApiService(InveniasNamespace.name);
    this.fileListProvider = {
      dataSourceApiService: dataSourceApiService,
      listType: InveniasListTypes.Documents,
      fileType: InveniasFileTypes.Document,
    };
    this.fileDataSourceApiService = sharedServiceProviderServiceFactory.getServiceProviderService(InveniasNamespace.name).getFileDataSourceApiService();
    this.workflowService = serviceProviderService.getWorkflowService(InveniasNamespace.name);
    this.namedEntityService = sharedServiceProviderServiceFactory.getServiceProviderService(InveniasNamespace.name).getNamedEntityService();
    this.iconService = serviceProviderService.getIconService(InveniasNamespace.name);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class InveniasMockFileListViewConfig implements IFileListViewConfig {
  readonly namespace = InveniasMockNamespace.name;
  readonly fileListProvider: IFileListProvider;
  readonly fileDataSourceApiService: IFileDataSourceApiService;
  readonly workflowService: IWorkflowService;
  readonly namedEntityService: INamedEntityService;
  readonly iconService: IIconService;
  readonly fileToPathConverter = new InveniasFileToPathConverter(InveniasListTypes.Documents);
  readonly localFileChecker = AlreadyExistsLocalFileChecker;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory) {
    const dataSourceApiService = serviceProviderService.getDataSourceApiService(InveniasMockNamespace.name);
    this.fileListProvider = {
      dataSourceApiService: dataSourceApiService,
      listType: InveniasListTypes.Documents,
      fileType: InveniasFileTypes.Document,
    };
    this.fileDataSourceApiService = sharedServiceProviderServiceFactory.getServiceProviderService(InveniasMockNamespace.name).getFileDataSourceApiService();
    this.workflowService = serviceProviderService.getWorkflowService(InveniasMockNamespace.name);
    this.namedEntityService = sharedServiceProviderServiceFactory
      .getServiceProviderService(InveniasMockNamespace.name)
      .getNamedEntityService();
    this.iconService = serviceProviderService.getIconService(InveniasMockNamespace.name);
  }
}
